
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"88","height":"88","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"88","height":"88","rx":"44","fill":"#ECEFF4"}}),_c('path',{attrs:{"d":"M44.293 41.928a3.32 3.32 0 00-.605 0c-4.363-.146-7.828-3.721-7.828-8.121 0-4.492 3.63-8.14 8.14-8.14 4.492 0 8.14 3.648 8.14 8.14-.019 4.4-3.483 7.974-7.847 8.121zM35.127 48.694c-4.437 2.97-4.437 7.81 0 10.761 5.041 3.373 13.31 3.373 18.351 0 4.437-2.97 4.437-7.81 0-10.761-5.023-3.355-13.291-3.355-18.351 0z","stroke":"#292D32","stroke-width":"1.295","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    